import TextLink from './component.styles'
export default TextLink
